/**
 * Auto-generated by tools/content-pipeline.
 * Pack: wordsearch-themedshape-v1
 * Item: wordsearch-travel
 * Generated: 2026-06-06T03:08:42.340Z
 * Generator: google/gemini-2.5-flash  |  Judge: anthropic/claude-sonnet-4.5
 * Accepted: 54 items (judge threshold 0.70)
 * Edit this file by re-running the pipeline; do not hand-edit unless you know what you are doing.
 */
export const travelWords = [
    {
        "word": "PARIS"
    },
    {
        "word": "ROME"
    },
    {
        "word": "CAIRO"
    },
    {
        "word": "BOSTON"
    },
    {
        "word": "DENVER"
    },
    {
        "word": "VENICE"
    },
    {
        "word": "ATHENS"
    },
    {
        "word": "MOSCOW"
    },
    {
        "word": "MADRID"
    },
    {
        "word": "LONDON"
    },
    {
        "word": "DUBLIN"
    },
    {
        "word": "VIENNA"
    },
    {
        "word": "TOKYO"
    },
    {
        "word": "SYDNEY"
    },
    {
        "word": "TRAIN"
    },
    {
        "word": "PLANE"
    },
    {
        "word": "SHIP"
    },
    {
        "word": "FERRY"
    },
    {
        "word": "TAXI"
    },
    {
        "word": "COACH"
    },
    {
        "word": "BOAT"
    },
    {
        "word": "BARGE"
    },
    {
        "word": "BICYCLE"
    },
    {
        "word": "SUBWAY"
    },
    {
        "word": "EIFFEL"
    },
    {
        "word": "PYRAMID"
    },
    {
        "word": "NIAGARA"
    },
    {
        "word": "HOOVER"
    },
    {
        "word": "COLOSSEUM"
    },
    {
        "word": "CANYON"
    },
    {
        "word": "PARTHENON"
    },
    {
        "word": "PASSPORT"
    },
    {
        "word": "SUITCASE"
    },
    {
        "word": "TICKET"
    },
    {
        "word": "DEPOT"
    },
    {
        "word": "HARBOR"
    },
    {
        "word": "ROUTE"
    },
    {
        "word": "VOYAGE"
    },
    {
        "word": "JOURNEY"
    },
    {
        "word": "HOTEL"
    },
    {
        "word": "MOTEL"
    },
    {
        "word": "CAMERA"
    },
    {
        "word": "COMPASS"
    },
    {
        "word": "ATLAS"
    },
    {
        "word": "LUGGAGE"
    },
    {
        "word": "CABIN"
    },
    {
        "word": "BERTH"
    },
    {
        "word": "CRUISE"
    },
    {
        "word": "PORT"
    },
    {
        "word": "PIER"
    },
    {
        "word": "WALK"
    },
    {
        "word": "STROLL"
    },
    {
        "word": "GUIDE"
    },
    {
        "word": "EXPLORE"
    }
];
//# sourceMappingURL=travel.js.map